module.exports = __webpack_public_path__ + "img/cake-19.2260826a.svg";